import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class NavBar extends Component {

  constructor(props) {
    super(props);
    this.state = {isOpen: false};
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    const {isAuthenticated, login, logout} = this.props;

    return (
      <div className="site-navbar">
        <div className="navbar-inner">
          <Link className="brand-mark" to="/">
            <span className="brand-glyph">S</span>
            SoReal
          </Link>

          <div className="nav-links">
            <Link className="nav-link-item" to="/">Home</Link>
            <Link className="nav-link-item" to="/person">Search by name</Link>
            <Link className="nav-link-item" to="/property">Search by address</Link>
            <Link className="nav-link-item" to="/about">About</Link>
            {isAuthenticated &&
              <Link className="nav-link-item" to="/subscriptionStatus">Account</Link>
            }
          </div>

          <div className="nav-cta-group">
            {!isAuthenticated ?
              <button className="btn-brand btn-brand-primary" onClick={login}>Log in</button> :
              <button className="btn-brand btn-brand-outline" onClick={logout}>Log out</button>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default NavBar;
